/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */

 let baseUrl=''
 let routerMode = ''

 if(process.env.NODE_ENV=="development"){
     //开发环境
    baseUrl = 'http://localhost:8989/stonghr/'
 }else if(process.env.NODE_ENV == 'production'){
     //生产环境
   baseUrl = 'https://service.stonghr.cn/stonghr/';
}else if(process.env.NODE_ENV == 'test'){
    //线上测试环境
	  baseUrl = 'http://129.204.68.217:8088/stonghr/';
}
export {
	baseUrl,
	routerMode,
}



//////////////////
// WEBPACK FOOTER
// ./config/env.js
// module id = AMf1
// module chunks = 517